import { doc, getDoc, setDoc } from "firebase/firestore";
import { db } from "../firebase";

export const QUOTA_AI_ADVISOR = 3;
export const QUOTA_PLANT_DOCTOR = 2;

export function getTodayDateString(): string {
  // YYYY-MM-DD in local timezone
  return new Date().toLocaleDateString('sv-SE');
}

function cleanOldLocalKeys(todayStr: string) {
  try {
    const keysToKeep = [
      `usage_aiAdvisor_${todayStr}`,
      `usage_plantDoctor_${todayStr}`
    ];
    const keysToRemove: string[] = [];
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key && (key.startsWith('usage_aiAdvisor_') || key.startsWith('usage_plantDoctor_'))) {
        if (!keysToKeep.includes(key)) {
          keysToRemove.push(key);
        }
      }
    }
    keysToRemove.forEach(key => localStorage.removeItem(key));
  } catch (e) {
    console.warn("Storage cleanup warning: ", e);
  }
}

export async function getUsageCount(userId: string | null, feature: 'aiAdvisor' | 'plantDoctor'): Promise<number> {
  const todayStr = getTodayDateString();
  cleanOldLocalKeys(todayStr);
  
  const localKey = `usage_${feature}_${todayStr}`;
  const localVal = localStorage.getItem(localKey);
  const localCount = localVal ? parseInt(localVal, 10) : 0;
  
  if (!userId) {
    return localCount;
  }
  
  try {
    const userRef = doc(db, 'users', userId);
    const userSnap = await getDoc(userRef);
    if (userSnap.exists()) {
      const data = userSnap.data();
      const usage = data?.usage?.[feature];
      if (usage && usage.date === todayStr) {
        // Synchronize with local storage
        localStorage.setItem(localKey, String(usage.count));
        return usage.count;
      }
    }
  } catch (error) {
    console.error(`Error retrieving ${feature} usage from Firestore:`, error);
  }
  
  return localCount;
}

export async function incrementUsage(userId: string | null, feature: 'aiAdvisor' | 'plantDoctor'): Promise<number> {
  const todayStr = getTodayDateString();
  const localKey = `usage_${feature}_${todayStr}`;
  const localVal = localStorage.getItem(localKey);
  const localCount = localVal ? parseInt(localVal, 10) : 0;
  const newCount = localCount + 1;
  
  localStorage.setItem(localKey, String(newCount));
  
  if (userId) {
    try {
      const userRef = doc(db, 'users', userId);
      await setDoc(userRef, {
        usage: {
          [feature]: {
            date: todayStr,
            count: newCount
          }
        }
      }, { merge: true });
    } catch (error) {
      console.error(`Error incrementing ${feature} usage on Firestore:`, error);
    }
  }
  
  return newCount;
}
